import { AddMoreButton, BasicNumberInput, DeleteButton } from "src/components";
import TextInput from "./TextInput";
import { useFieldArray } from "react-hook-form";
import { useSelector } from "react-redux";

const SelectQuestionInputs = ({ question, errors, handleChange, control }) => {
  const { fields, append, remove } = useFieldArray({
    control: control,
    name: `answers`,
  });

  const darkMode = useSelector((state) => state.coreui.darkMode);

  if (!question) return null;

  return (
    <>
      <TextInput
        handleChange={handleChange}
        name={`label`}
        value={question?.label}
        errors={errors}
        label={"Question"}
        labelClassname={"font-bold"}
      />
      <TextInput
        value={question?.labelExternal}
        name={`labelExternal`}
        handleChange={handleChange}
        label={"External Question"}
        errors={errors}
        info={"Use {ORG_NAME} to insert the organization name in the question."}
        labelClassname={"font-bold"}
      />
      <p className=" mb-0 font-bold">Answers:</p>
      <div className="pr-3 ">
        {fields?.map((field, i) => {
          return (
            <div
              style={!darkMode ? { backgroundColor: "#f8f9fa" } : {}}
              className="w-100 rounded border p-3 mb-3"
              key={field.id}
            >
              <div className="d-flex w-100 justify-content-between">
                <div className="d-flex  align-items-baseline ">
                  <span className="mr-2 font-bold">Points</span>
                  <BasicNumberInput
                    value={field.value}
                    name={`answers.${i}.value`}
                    onChange={handleChange}
                    label={"Points"}
                    errors={errors}
                    min={0}
                    max={10}
                    decimalScale={0}
                  />
                </div>
                <DeleteButton
                  onClick={() => remove(i)}
                  style={{ height: "40px" }}
                />
              </div>
              <TextInput
                value={field.label}
                name={`answers.${i}.label`}
                handleChange={handleChange}
                errors={errors}
                className="mb-3"
              />
            </div>
          );
        })}
        <AddMoreButton
          label={"Add answer"}
          onClick={() => append({ label: "", value: 0 })}
        />
      </div>
    </>
  );
};

export default SelectQuestionInputs;
